import React from 'react';
import SelectOption from '../../../infrastructure/types/SelectOption';
import {generateKey} from '../../../infrastructure/helpers/react/commonHelper';

const createOption = (option: SelectOption): JSX.Element => {
    return (
        <option key={generateKey()} value={option.value} disabled={option.disabled} className='border-1px-ccc'>{option.text}</option>
    );
};

const createSelectContent = (options: SelectOption[]): JSX.Element[] => {

    return options.map(createOption);
};

const createEmptyOption = (): JSX.Element => createOption({ value: '', text: '' });

export { createEmptyOption, createSelectContent };
